// The store's record of the run in play: which autosaves belong to it (runId), the config it
// is played on (a save's snapshot when it differs from the current balance, ADR-0008) and the
// envelope it was loaded from (for "fork onto the current balance", 24.12).
import type { Config } from '../sim/api';
import type { SaveEnvelope } from '../persist';

export interface RunContext {
  runId: string;
  /** Undefined means the current config (the api's default). */
  cfg: Config | undefined;
  /** The envelope the run was loaded from, if any. */
  envelope: SaveEnvelope | null;
}

let run: RunContext = { runId: '', cfg: undefined, envelope: null };

export function currentRun(): RunContext {
  return run;
}

/** The id of the run in play (save lists mark "this run"). */
export function currentRunId(): string {
  return run.runId;
}

export function setRun(next: RunContext): void {
  run = next;
}

/** The run's config for api calls whose options object has an optional `cfg`. */
export function cfgOption(): { cfg?: Config } {
  return run.cfg === undefined ? {} : { cfg: run.cfg };
}

/** The run's config for api calls with a `cfg = config` parameter (undefined = current). */
export function runConfig(): Config | undefined {
  return run.cfg;
}

/** A new run id: the seed plus a clock suffix (UI-side, 24.13: never enters the sim). */
export function newRunId(seed: string): string {
  const base = seed.replace(/[^a-z0-9]+/gi, '').slice(0, 16) || 'run';
  return `${base}-${Date.now().toString(36)}`;
}
